import { Filmomtale } from "@filmweb/sanity-types";
import { PortableTextBlock } from "@sanity/types";
import classNames from "classnames";
import { CMSCroppedImage } from "components/images/Image";
import RichText from "components/richtext/RichText";
import { DocumentType_MOVIE, FwPakkeImageDocument, getUrl, IMovieArticle, INewsArticle, ISpecialShowArticle } from "lib/types/sanity";
import Link from "next/link";
import styles from "./ArticleItem.module.css";


//#region [Props]
type ArticleItemProps = {
    article: (ISpecialShowArticle | INewsArticle | IMovieArticle);
    className?: string;
    film?: Filmomtale;
    allowTitleOverride?: boolean;
};
//#endregion


//#region [Component]
export default function ArticleItem({ article, className, film, allowTitleOverride }: ArticleItemProps) {
    const filmImage = film?.mainImageV2 ?? film?.imagesV2?.[0];

    let oneliner: string | undefined;
    let ingress: PortableTextBlock[] | undefined = article.frontpageText ?? article.ingress ?? film?.ingress;
    if (article._type === DocumentType_MOVIE) {
        oneliner = (article as IMovieArticle).oneliner;
    }

    let title: string = film?.title ?? article.title;
    if (allowTitleOverride && 'titleOverride' in article && article.titleOverride) {
        title = article.titleOverride as string;
    }

    const url = getUrl(article);
    if (!url) {
        return null;
    }
    return <article className={classNames(styles.SArticleItem, className)}>
        <Link href={url}>
            <div className={styles.SImageContainer}>
                {article.image && <CMSCroppedImage image={article.image as FwPakkeImageDocument} width={480} heightRatio={1} />}
                {!article.image && filmImage && <CMSCroppedImage image={filmImage} width={480} heightRatio={1} isFilmweb />}
            </div>
            <div className={styles.STextContainer}>
                <h1 className={styles.SArticleTitle}>{title}</h1>
                {oneliner && <p className={classNames(styles.ellipsis, styles.SOneliner)}>{oneliner}</p>}
                {!oneliner && <RichText className={classNames(styles.ellipsis, styles.SIngress)} value={ingress} disableLinks />}
            </div>
        </Link>
    </article>;
}
//#endregion